
<style scoped lang="scss">
.address-add-wrapper /deep/ {
    .van-button--danger {
        background: linear-gradient(
            91deg,
            rgba(248, 200, 64, 1) 0%,
            rgba(245, 149, 38, 1) 100%
        );
        border-radius: 0.613333rem;
        border: 0;
    }
    .van-address-edit__buttons .van-button {
        border-radius: 0.613333rem;
        .van-button__text {
            font-size: 16px;
        }
    }
    .van-switch--on {
        background-color: $orange2;
    }
    .van-cell__title span {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 1.026667rem;
        color: $grey5;
    }
    .van-field__body ::-webkit-input-placeholder {
        color: #cdcdcd;
        font-size: 16px;
        font-weight: 400;
        line-height: 0.586667rem;
    }
}
</style>

<template>
    <div class="address-add-wrapper">
        <van-address-edit
            :area-list="areaList"
            :address-info="addressInfo"
            save-button-text="保    存"
            delete-button-text="删    除"
            show-delete
            show-set-default
            @save="onSave"
            @delete="onDelete"
            @change-area="onChangeArea"
        />
    </div>
</template>

<script>
import areaList from "../../js/area";
export default {
    name: "UserAddressEdit",
    components: {},
    props: {
        // layouts: String,
        // layoutType: String,
    },
    data() {
        return {
            areaList,
            addressInfo: {},
        };
    },
    computed: {},
    watch: {},
    created() {
        //{id:3,name:'xxx',tel:'234-213454',addressDetail:'asdfasihd',isDefault:true}
        if (this.$route.params.type === 1) {
            this.addressInfo = JSON.parse(sessionStorage.currentAddress);
        } else {
            this.addressInfo = {};
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        onSave(content) {
            if (!content.name) {
                this.$toast("请填写姓名！");
                return false;
            }
            if (content.name.length > 25) {
                this.$toast("姓名不能超过25个字！");
                return false;
            }
            this.postAddress(content);
        },
        onDelete(content) {
            this.deleteAddress(content.id);
        },
        onChangeArea(values) {},
        postAddress(e) {
            let body = {
                real_name: e.name,
                phone: e.tel,
                detail: e.addressDetail,
                province: e.province === e.city ? "" : e.province,
                city: e.city,
                county: e.county,
                area_code: e.areaCode,
                is_default: e.isDefault ? "1" : "0",
            };
            const URL =
                this.$route.params.type === 1
                    ? `${window.API.user.updateAddress}/${e.id}?token=${sessionStorage.token}`
                    : `${window.API.user.addAddress}?token=${sessionStorage.token}`;
            this.$axios
                .post(URL, body)
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.$toast(
                            `${
                                this.$route.params.type === 1 ? "修改" : "新增"
                            }地址成功！`
                        );
                        this.$router.go(-1);
                        if (this.$route.query.first) {
                            sessionStorage.addedAddressId = data.data.insertId;
                        }
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
        deleteAddress(id) {
            const URL = `${window.API.user.deleteAddress}/${id}?token=${sessionStorage.token}`;
            this.$axios
                .post(URL)
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.$toast(`删除成功！`);
                        this.$router.go(-1);
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
    },
};
</script>
